import { addYears, format } from 'date-fns'

import { BUDGET, DIGITAL_ALLOCATION_TYPE_BUDGET, NAME, RIGHT_TYPE, RIGHT_TYPE_DIGITAL, STATUS } from '../../../fields'
import { RIGHT_STATUS } from '../../../../../../../constants/rights'
import { DATES_FORMAT_BE } from '../../../../../../../constants/dates'

export const transformValuesToBE = values => {
  return {
    [NAME]: values[NAME],
    [BUDGET]: values[BUDGET],

    // hardcoded values
    [STATUS]: RIGHT_STATUS.LIVE,
    [RIGHT_TYPE]: RIGHT_TYPE_DIGITAL,
    allocation_type: DIGITAL_ALLOCATION_TYPE_BUDGET,
    start_date: format(new Date(), DATES_FORMAT_BE),
    end_date: format(addYears(new Date(), 2), DATES_FORMAT_BE)
  }
}
